const TOKEN_PATTERN = "\\{\\{(.+?)\\|(.+?)\\}\\}";

/**
 * Factory de regex global para parsing de tokens. Cada call retorna uma
 * **nova instância** — segura para uso com `.exec()` em loop mesmo quando
 * funções chamadas internamente usam `.replace()` no mesmo pattern.
 */
export function createTokenRegex(): RegExp {
  return new RegExp(TOKEN_PATTERN, "g");
}

/**
 * Versão âncorada — casa apenas quando o template inteiro é exatamente um
 * único token. Sem flag global → sem `lastIndex` mutável → seguro como
 * singleton. Usada por `extractImage` para detectar single-token mode.
 */
export const SINGLE_TOKEN_REGEX = new RegExp(`^${TOKEN_PATTERN}$`);
